import { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import {useSessionData} from "../../auth/SessionDataProvider";

export default function useScratchSize(defaultValue = null) {
    const { isSmallScreen } = useSessionData();
    const [scratchSize, setScratchSizeState] = useState(() => {
        const saved = Cookies.get('scratchSize');
        return saved !== undefined ? parseInt(saved) : defaultValue ?? (isSmallScreen ? 25 : 50);
    });

    useEffect(() => {
        const handleStorageChange = () => {
            const updated = Cookies.get('scratchSize');
            if (updated !== undefined) {
                setScratchSizeState(parseInt(updated));
            }
        };

        const interval = setInterval(handleStorageChange, 500);
        return () => clearInterval(interval);
    }, []);

    const setScratchSize = (value) => {
        Cookies.set('scratchSize', value.toString(), { expires: 365 });
        setScratchSizeState(value);
    };

    return [scratchSize, setScratchSize];
}
